import { TranslationsDto } from 'api/dto';

import { Translations } from './types';

import translationAmharic from 'translations/amharic.json';
import translationEnglish from 'translations/english.json';
import translationItalian from 'translations/italian.json';
import translationFrench from 'translations/french.json';
import translationArabic from 'translations/arabic.json';
import translationTunisianArabic from 'translations/tunisianArabic.json';
import translationSpanish from 'translations/spanish.json';
import translationPortuguese from 'translations/portuguese.json';

export * from './types';

export const baseTranslations: Translations = {
  'English': translationEnglish,
  'Spanish': translationSpanish,
  'Portuguese': translationPortuguese,
  'Amharic': translationAmharic,
  'Italian': translationItalian,
  'French': translationFrench,
  'Arabic': translationArabic,
  'Tunisian Arabic': translationTunisianArabic
}

export const createFullTranslations = (dto: TranslationsDto): Translations => {
  const occupationsEnglish = dto.find(t => t.language === 'English')?.occupation ?? {};
  const occupationsSpanish = dto.find(t => t.language === 'Spanish')?.occupation ?? {};
  const occupationsPortuguese = dto.find(t => t.language === 'Portuguese')?.occupation ?? {};
  const occupationsAmharic = dto.find(t => t.language === 'Amharic')?.occupation ?? {};
  const occupationsItalian = dto.find(t => t.language === 'Italian')?.occupation ?? {};
  const occupationsFrench = dto.find(t => t.language === 'French')?.occupation ?? {};
  const occupationsArabic = dto.find(t => t.language === 'Arabic')?.occupation ?? {};
  const occupationsTunisianArabic = dto.find(t => t.language === 'Tunisian Arabic')?.occupation
      ?? {};

  return {
    'English': {
      ...baseTranslations['English'],
      CareerOptionCard: {
        ...baseTranslations['English'].CareerOptionCard,
        occupations: occupationsEnglish
      }
    },
    'Spanish': {
      ...baseTranslations['Spanish'],
      CareerOptionCard: {
        ...baseTranslations['Spanish'].CareerOptionCard,
        occupations: occupationsSpanish
      }
    },
    'Portuguese': {
      ...baseTranslations['Portuguese'],
      CareerOptionCard: {
        ...baseTranslations['Portuguese'].CareerOptionCard,
        occupations: occupationsPortuguese
      }
    },
    'Amharic': {
      ...baseTranslations['Amharic'],
      CareerOptionCard: {
        ...baseTranslations['Amharic'].CareerOptionCard,
        occupations: occupationsAmharic
      }
    },
    'Italian': {
      ...baseTranslations['Italian'],
      CareerOptionCard: {
        ...baseTranslations['Italian'].CareerOptionCard,
        occupations: occupationsItalian
      }
    },
    'French': {
      ...baseTranslations['French'],
      CareerOptionCard: {
        ...baseTranslations['French'].CareerOptionCard,
        occupations: occupationsFrench
      }
    },
    'Arabic': {
      ...baseTranslations['Arabic'],
      CareerOptionCard: {
        ...baseTranslations['Arabic'].CareerOptionCard,
        occupations: occupationsArabic
      }
    },
    'Tunisian Arabic': {
      ...baseTranslations['Tunisian Arabic'],
      CareerOptionCard: {
        ...baseTranslations['Tunisian Arabic'].CareerOptionCard,
        occupations: occupationsTunisianArabic
      }
    },
  }
}
